export default "__VITE_ASSET__C3nsF1Lg__"